// UI 전역 상태 — 변경 검토·모니터링 서비스 노출 여부.
//
// 두 서비스는 이제 기본 노출이다. 푸터 저작권 문구를 7번 연속 클릭하면(이스터에그)
// 숨김/노출을 토글할 수 있으며, 그 선택만 새로고침 후에도 유지되도록 localStorage에
// 보관한다(기본값은 저장하지 않고 '숨김' 선택만 'false'로 남긴다).

import { create } from 'zustand'

const STORAGE_KEY = 'haccp-hidden-services-revealed'

function readInitial(): boolean {
    try {
        // 기본 노출: 명시적으로 'false'(숨김 선택)인 경우에만 숨긴다.
        return localStorage.getItem(STORAGE_KEY) !== 'false'
    } catch {
        return true
    }
}

function persist(revealed: boolean): void {
    try {
        if (revealed) localStorage.removeItem(STORAGE_KEY)
        else localStorage.setItem(STORAGE_KEY, 'false')
    } catch {
        // localStorage 불가 환경(시크릿 모드 등)이면 세션 한정으로만 반영한다.
    }
}

interface UiState {
    /** 숨김 서비스(변경 검토·모니터링) 노출 여부. */
    hiddenServicesRevealed: boolean
    /** 이스터에그(푸터 7연속 클릭) — 노출/숨김을 토글한다. */
    toggleHiddenServices(): void
}

export const useUiStore = create<UiState>()((set) => ({
    hiddenServicesRevealed: readInitial(),

    toggleHiddenServices: () =>
        set((state) => {
            const next = !state.hiddenServicesRevealed
            persist(next)
            return { hiddenServicesRevealed: next }
        }),
}))
